module.exports = __webpack_public_path__ + "media/images/svg/clients/12-0279c6f9b43fcfbdae555599df89ac5d.svg";